import { useState, useMemo, useRef, useEffect } from "react";
import { supabase } from './supabase';

// ── Catalog Categories (expanded from Excel analysis) ──
const CATALOG_CATS = {
  "Tile":                 { color:"#c9a96e", bg:"rgba(201,169,110,0.12)", icon:"🏛️", desc:"Porcelain, marble, mosaic, bullnose, thresholds" },
  "Adhesive & Grout":     { color:"#6b8cae", bg:"rgba(107,140,174,0.12)", icon:"🪣", desc:"Thinset, mortar bed, epoxy grout, silicone" },
  "Waterproofing":        { color:"#7b6bc4", bg:"rgba(123,107,196,0.12)", icon:"🛡️", desc:"Kerdi, Ditra, RedGard, Go Board, sealants" },
  "Subfloor & Prep":      { color:"#8c7b6e", bg:"rgba(140,123,110,0.12)", icon:"📐", desc:"OSB, cement board, leveler, wire mesh" },
  "Lumber & Framing":     { color:"#946c00", bg:"rgba(148,108,0,0.12)",   icon:"🪵", desc:"2x4, 2x6, greenboard, drywall, mud" },
  "Hardware & Fasteners": { color:"#6b5e52", bg:"rgba(107,94,82,0.12)",   icon:"🔩", desc:"Screws, nails, clips, trim strips" },
  "Fixtures & Plumbing":  { color:"#0b7285", bg:"rgba(11,114,133,0.12)",  icon:"🚿", desc:"Shower heads, faucets, drains, toilets" },
  "Cabinets & Counters":  { color:"#c4954a", bg:"rgba(196,149,74,0.12)",  icon:"🗄️", desc:"Vanities, base cabinets, stone tops" },
  "Paint & Finish":       { color:"#2d6a4f", bg:"rgba(45,106,79,0.12)",   icon:"🎨", desc:"Wall paint, ceiling paint, high gloss" },
  "Equipment Rental":     { color:"#c92a2a", bg:"rgba(201,42,42,0.12)",   icon:"🏗️", desc:"Jack hammer, dump truck, steam cleaner" },
  "Cleaning Supplies":    { color:"#3b5bdb", bg:"rgba(59,91,219,0.12)",   icon:"🧹", desc:"Commercial agents, acid cleaner, disinfectant" },
  "Doors & Trim":         { color:"#6a1b9a", bg:"rgba(106,27,154,0.12)",  icon:"🚪", desc:"Solid doors, knobs, hinges, baseboard" },
  "Electrical & Lighting":{ color:"#e67700", bg:"rgba(230,119,0,0.12)",   icon:"💡", desc:"GFCI outlets, light fixtures, exhaust fans" },
  "Glass":                { color:"#1a6b2a", bg:"rgba(26,107,42,0.12)",   icon:"🪟", desc:"Shower doors, knee wall glass panels" },
};

const SUPPLIERS = ["The Tile Shop","Home Depot","Lowe's","Floor & Decor","Schluter","Mapei","Laticrete","Wholesale Supply","Local Vendor","Other"];
const UNITS = ["sqft","ea","bag","box","gal","roll","sheet","ft","lb","set","day","job"];

// ── Seed catalog from actual Excel project data ──
const initCatalog = [
  // Tile
  { id:1,  name:"Versatile Mid Grey Porcelain 12x24",  cat:"Tile",              supplier:"The Tile Shop",  unit:"ea",  lastPrice:13.79,  upcharge:15, url:"https://www.tileshop.com/products/versatile-mid-grey-matte-porcelain-wall-and-floor-tile-12-x-24-in-681178", notes:"Popular for bathrooms, matte finish", usageCount:3 },
  { id:2,  name:"Purity White Satin Porcelain 12x24",  cat:"Tile",              supplier:"Floor & Decor",  unit:"sqft",lastPrice:4.49,   upcharge:15, url:"https://www.flooranddecor.com/porcelain-tile/sahara-sand-porcelain-tile-100054170.html", notes:"Wall tile, satin finish", usageCount:2 },
  { id:3,  name:"San Grigigio Porcelain",               cat:"Tile",              supplier:"The Tile Shop",  unit:"ea",  lastPrice:36.08,  upcharge:20, url:"", notes:"Large format premium tile", usageCount:4 },
  { id:4,  name:"Dolomite Iceberg Marble",               cat:"Tile",              supplier:"The Tile Shop",  unit:"ea",  lastPrice:113.95, upcharge:20, url:"", notes:"Premium natural marble slab", usageCount:3 },
  { id:5,  name:"Chastaint Ivory Porcelain",             cat:"Tile",              supplier:"The Tile Shop",  unit:"ea",  lastPrice:18.66,  upcharge:15, url:"", notes:"Classic ivory floor tile", usageCount:2 },
  { id:6,  name:"Bullnose Trim Piece",                   cat:"Tile",              supplier:"The Tile Shop",  unit:"ea",  lastPrice:5.49,   upcharge:10, url:"", notes:"Edge finishing trim", usageCount:2 },
  { id:7,  name:"Shower Floor Mosaic",                   cat:"Tile",              supplier:"The Tile Shop",  unit:"ea",  lastPrice:26.49,  upcharge:15, url:"", notes:"Small format for shower pans", usageCount:1 },
  { id:8,  name:"Marble Threshold",                      cat:"Tile",              supplier:"The Tile Shop",  unit:"ea",  lastPrice:150.00, upcharge:20, url:"", notes:"Door transition piece", usageCount:2 },

  // Adhesive & Grout
  { id:9,  name:"Mapei Keraflex Thinset",                cat:"Adhesive & Grout",  supplier:"Home Depot",     unit:"bag", lastPrice:27.00,  upcharge:15, url:"", notes:"Standard thinset mortar, 25lb bag", usageCount:6 },
  { id:10, name:"Mapei Perma Grout",                     cat:"Adhesive & Grout",  supplier:"Home Depot",     unit:"bag", lastPrice:20.00,  upcharge:12, url:"", notes:"Sanded grout, multiple colors avail", usageCount:4 },
  { id:11, name:"Spectra Lock Epoxy Grout",              cat:"Adhesive & Grout",  supplier:"The Tile Shop",  unit:"ea",  lastPrice:99.00,  upcharge:15, url:"", notes:"Premium epoxy — stain proof", usageCount:2 },
  { id:12, name:"Laticrete 254 Platinum Bond",           cat:"Adhesive & Grout",  supplier:"Floor & Decor",  unit:"bag", lastPrice:53.00,  upcharge:15, url:"", notes:"Large format tile adhesive", usageCount:2 },
  { id:13, name:"Flexbond Thinset",                      cat:"Adhesive & Grout",  supplier:"Home Depot",     unit:"bag", lastPrice:36.00,  upcharge:12, url:"", notes:"Flexible mortar for movement", usageCount:1 },
  { id:14, name:"Laticrete Perma Grout",                 cat:"Adhesive & Grout",  supplier:"Floor & Decor",  unit:"bag", lastPrice:31.39,  upcharge:12, url:"", notes:"25lb bags, multiple colors", usageCount:2 },
  { id:15, name:"Laticrete Silicone Sealant",            cat:"Adhesive & Grout",  supplier:"Floor & Decor",  unit:"ea",  lastPrice:15.29,  upcharge:10, url:"", notes:"Color-matched silicone", usageCount:2 },
  { id:16, name:"Exterior Epoxy Grout 1 Gallon",         cat:"Adhesive & Grout",  supplier:"Home Depot",     unit:"gal", lastPrice:120.00, upcharge:15, url:"", notes:"Outdoor rated epoxy grout", usageCount:1 },

  // Waterproofing
  { id:17, name:"Schluter Kerdi Kit 48x72",              cat:"Waterproofing",     supplier:"The Tile Shop",  unit:"ea",  lastPrice:1000.00,upcharge:40, url:"", notes:"Complete shower waterproofing system", usageCount:3 },
  { id:18, name:"Schluter Kerdi Ditra",                  cat:"Waterproofing",     supplier:"The Tile Shop",  unit:"roll",lastPrice:120.16, upcharge:25, url:"", notes:"Uncoupling membrane, per roll", usageCount:3 },
  { id:19, name:"Schluter Kerdi Board",                  cat:"Waterproofing",     supplier:"The Tile Shop",  unit:"ea",  lastPrice:108.00, upcharge:20, url:"", notes:"Waterproof building panel", usageCount:2 },
  { id:20, name:"RedGard Waterproofing",                 cat:"Waterproofing",     supplier:"Home Depot",     unit:"gal", lastPrice:50.00,  upcharge:10, url:"", notes:"Liquid applied membrane", usageCount:2 },
  { id:21, name:"Go Board Tile Backer",                  cat:"Waterproofing",     supplier:"Home Depot",     unit:"ea",  lastPrice:30.00,  upcharge:15, url:"", notes:"Waterproof tile backer board", usageCount:2 },
  { id:22, name:"Kerdi Fix Sealant",                     cat:"Waterproofing",     supplier:"Floor & Decor",  unit:"ea",  lastPrice:30.70,  upcharge:10, url:"https://www.flooranddecor.com/shower-systems-installation-materials/schluter-kerdi-fix-sealing-and-bonding-compound-gray-951200268.html", notes:"Sealing and bonding compound", usageCount:2 },
  { id:23, name:"Schluter Shower Curb",                  cat:"Waterproofing",     supplier:"The Tile Shop",  unit:"ea",  lastPrice:73.27,  upcharge:15, url:"", notes:"Pre-formed shower curb", usageCount:1 },
  { id:24, name:"Schluter Trim Sticks",                  cat:"Waterproofing",     supplier:"The Tile Shop",  unit:"ea",  lastPrice:27.27,  upcharge:12, url:"", notes:"Metal edge trim profiles", usageCount:2 },
  { id:25, name:"Sikaflex Joint Sealant",                cat:"Waterproofing",     supplier:"Home Depot",     unit:"ea",  lastPrice:10.00,  upcharge:10, url:"", notes:"Expansion joint sealant", usageCount:1 },

  // Subfloor & Prep
  { id:26, name:"Subfloor OSB 3/4 inch",                cat:"Subfloor & Prep",   supplier:"Home Depot",     unit:"sheet",lastPrice:32.98, upcharge:15, url:"", notes:"Oriented strand board, 4x8 sheet", usageCount:4 },
  { id:27, name:"Cement Board 1/2 inch",                 cat:"Subfloor & Prep",   supplier:"Home Depot",     unit:"sheet",lastPrice:12.00, upcharge:12, url:"", notes:"Standard backer board", usageCount:3 },
  { id:28, name:"Floor Leveler (self-leveling)",         cat:"Subfloor & Prep",   supplier:"Home Depot",     unit:"bag", lastPrice:336.89, upcharge:20, url:"", notes:"Mapei self-level plus, large bag", usageCount:1 },
  { id:29, name:"Mapei Self Level Plus",                 cat:"Subfloor & Prep",   supplier:"Home Depot",     unit:"bag", lastPrice:28.98,  upcharge:15, url:"", notes:"Self-leveling underlayment", usageCount:1 },
  { id:30, name:"Wire Mesh 16ga 2x2 (50ft)",            cat:"Subfloor & Prep",   supplier:"Home Depot",     unit:"roll",lastPrice:70.00,  upcharge:12, url:"", notes:"Reinforcing mesh for mud beds", usageCount:1 },
  { id:31, name:"Laticrete 3701 Mortar Bed",             cat:"Subfloor & Prep",   supplier:"Floor & Decor",  unit:"bag", lastPrice:38.00,  upcharge:12, url:"", notes:"Deck mud / mortar bed mix", usageCount:2 },
  { id:32, name:"Subfloor Sealant",                      cat:"Subfloor & Prep",   supplier:"Home Depot",     unit:"ea",  lastPrice:5.58,   upcharge:10, url:"", notes:"Adhesive sealant for subfloor", usageCount:2 },
  { id:33, name:"1 Gallon Blue Top Primer",              cat:"Subfloor & Prep",   supplier:"Home Depot",     unit:"gal", lastPrice:30.00,  upcharge:10, url:"", notes:"Primer for substrate", usageCount:1 },

  // Lumber & Framing
  { id:34, name:"2x4 Stud",                              cat:"Lumber & Framing",  supplier:"Home Depot",     unit:"ea",  lastPrice:3.75,   upcharge:15, url:"", notes:"Standard framing lumber", usageCount:5 },
  { id:35, name:"2x6 Board",                             cat:"Lumber & Framing",  supplier:"Home Depot",     unit:"ea",  lastPrice:7.33,   upcharge:15, url:"", notes:"Structural framing lumber", usageCount:2 },
  { id:36, name:"2x12 Board",                            cat:"Lumber & Framing",  supplier:"Home Depot",     unit:"ea",  lastPrice:8.50,   upcharge:15, url:"", notes:"Heavy framing / joist", usageCount:1 },
  { id:37, name:"Greenboard Drywall",                    cat:"Lumber & Framing",  supplier:"Home Depot",     unit:"sheet",lastPrice:21.31, upcharge:12, url:"", notes:"Moisture resistant drywall", usageCount:3 },
  { id:38, name:"20 Minute Joint Compound",              cat:"Lumber & Framing",  supplier:"Home Depot",     unit:"bag", lastPrice:12.70,  upcharge:10, url:"", notes:"Quick-set mud for patching", usageCount:2 },

  // Hardware & Fasteners
  { id:39, name:"Cement Board Screws",                   cat:"Hardware & Fasteners",supplier:"Home Depot",   unit:"box", lastPrice:20.00,  upcharge:10, url:"", notes:"Corrosion resistant", usageCount:3 },
  { id:40, name:"#8 Star Drive Screws 10lb",             cat:"Hardware & Fasteners",supplier:"Home Depot",   unit:"box", lastPrice:44.98,  upcharge:10, url:"", notes:"General purpose construction", usageCount:2 },
  { id:41, name:"2\" Framing Gun Nails",                 cat:"Hardware & Fasteners",supplier:"Home Depot",   unit:"box", lastPrice:44.38,  upcharge:10, url:"", notes:"Collated framing nails", usageCount:2 },
  { id:42, name:"18ga Finish Nails",                     cat:"Hardware & Fasteners",supplier:"Home Depot",   unit:"box", lastPrice:20.00,  upcharge:10, url:"", notes:"Brad nails for trim", usageCount:2 },
  { id:43, name:"Level Clips (400 pack)",                cat:"Hardware & Fasteners",supplier:"Home Depot",   unit:"box", lastPrice:89.99,  upcharge:12, url:"", notes:"Tile leveling system base clips", usageCount:3 },
  { id:44, name:"Level Clip Tops",                       cat:"Hardware & Fasteners",supplier:"Home Depot",   unit:"box", lastPrice:22.98,  upcharge:10, url:"", notes:"Tile leveling wedge tops", usageCount:2 },

  // Fixtures & Plumbing
  { id:45, name:"Delta Handheld Shower Head",            cat:"Fixtures & Plumbing",supplier:"Home Depot",    unit:"ea",  lastPrice:579.00, upcharge:20, url:"", notes:"Premium shower system with diverter", usageCount:3 },
  { id:46, name:"Wall Mount Faucet",                     cat:"Fixtures & Plumbing",supplier:"Home Depot",    unit:"ea",  lastPrice:200.00, upcharge:25, url:"", notes:"Matte black / brushed nickel", usageCount:2 },
  { id:47, name:"Shower Drain Assembly",                 cat:"Fixtures & Plumbing",supplier:"Home Depot",    unit:"ea",  lastPrice:100.00, upcharge:10, url:"", notes:"Linear or point drain", usageCount:2 },
  { id:48, name:"Flo FX Drain Grate",                   cat:"Fixtures & Plumbing",supplier:"Other",         unit:"ea",  lastPrice:35.00,  upcharge:10, url:"https://flofx.com/product/xfactor/", notes:"X-Factor decorative grate", usageCount:1 },
  { id:49, name:"Flo FX Flange Kit",                    cat:"Fixtures & Plumbing",supplier:"Other",         unit:"ea",  lastPrice:45.00,  upcharge:10, url:"https://flofx.com/product/universal-outlet-bond-flange-kit/", notes:"Universal outlet bond flange", usageCount:1 },
  { id:50, name:"Tub Drain Kit (Matte Black)",           cat:"Fixtures & Plumbing",supplier:"Home Depot",    unit:"ea",  lastPrice:31.31,  upcharge:10, url:"", notes:"Touch-toe tub drain assembly", usageCount:1 },
  { id:51, name:"Deep Soaking Bathtub 60x32",            cat:"Fixtures & Plumbing",supplier:"Home Depot",    unit:"ea",  lastPrice:299.00, upcharge:15, url:"", notes:"Delta Classic 500 alcove tub", usageCount:1 },
  { id:52, name:"Pex Plumbing Supplies Kit",             cat:"Fixtures & Plumbing",supplier:"Home Depot",    unit:"set", lastPrice:100.00, upcharge:10, url:"", notes:"Pex fittings, tubing, connectors", usageCount:2 },
  { id:53, name:"Toilet (Comfort Height)",               cat:"Fixtures & Plumbing",supplier:"Home Depot",    unit:"ea",  lastPrice:250.00, upcharge:15, url:"", notes:"ADA comfort height toilet", usageCount:1 },

  // Cabinets & Counters
  { id:54, name:"Base Cabinet w/ Stone Top",             cat:"Cabinets & Counters",supplier:"Wholesale Supply",unit:"ea", lastPrice:500.00, upcharge:25, url:"", notes:"Vanity with stone countertop", usageCount:2 },
  { id:55, name:"Wholesale Cabinet Supply Set",          cat:"Cabinets & Counters",supplier:"Wholesale Supply",unit:"set",lastPrice:4153.78,upcharge:10, url:"", notes:"Full kitchen cabinet package", usageCount:1 },
  { id:56, name:"Vessel Sink",                           cat:"Cabinets & Counters",supplier:"Home Depot",    unit:"ea",  lastPrice:60.80,  upcharge:12, url:"", notes:"Above-counter bowl sink", usageCount:2 },
  { id:57, name:"Moen Wood Bench (shower)",              cat:"Cabinets & Counters",supplier:"Home Depot",    unit:"ea",  lastPrice:244.99, upcharge:20, url:"", notes:"Teak shower bench", usageCount:2 },
  { id:58, name:"Bathroom LED Mirror",                   cat:"Cabinets & Counters",supplier:"Home Depot",    unit:"ea",  lastPrice:185.99, upcharge:10, url:"", notes:"Lighted vanity mirror", usageCount:3 },

  // Glass
  { id:59, name:"Frameless Glass Shower Door",           cat:"Glass",             supplier:"Local Vendor",   unit:"ea",  lastPrice:1000.00,upcharge:15, url:"", notes:"Custom measured glass door", usageCount:2 },
  { id:60, name:"Knee Wall Glass Panel",                 cat:"Glass",             supplier:"Local Vendor",   unit:"ea",  lastPrice:200.00, upcharge:25, url:"", notes:"Half wall glass panel", usageCount:1 },

  // Equipment Rental
  { id:61, name:"Jack Hammer (daily rate)",              cat:"Equipment Rental",  supplier:"Home Depot",     unit:"day", lastPrice:77.00,  upcharge:30, url:"", notes:"Electric demo hammer rental", usageCount:4 },
  { id:62, name:"Dump Truck Load",                       cat:"Equipment Rental",  supplier:"Local Vendor",   unit:"ea",  lastPrice:325.00, upcharge:10, url:"", notes:"Debris removal per load", usageCount:5 },
  { id:63, name:"Steam Cleaner Rental",                  cat:"Equipment Rental",  supplier:"Home Depot",     unit:"day", lastPrice:400.00, upcharge:25, url:"", notes:"Industrial steam cleaning unit", usageCount:1 },

  // Electrical & Lighting
  { id:64, name:"Exhaust Fan (70 CFM)",                  cat:"Electrical & Lighting",supplier:"Home Depot",  unit:"ea",  lastPrice:62.99,  upcharge:15, url:"", notes:"Delta Breez Slim Series", usageCount:2 },
  { id:65, name:"Vanity Light Fixture",                  cat:"Electrical & Lighting",supplier:"Home Depot",  unit:"ea",  lastPrice:75.00,  upcharge:15, url:"", notes:"2-3 light bath fixture", usageCount:2 },

  // Doors & Trim
  { id:66, name:"Quarter Round Trim",                    cat:"Doors & Trim",      supplier:"Home Depot",     unit:"ea",  lastPrice:18.00,  upcharge:10, url:"", notes:"Floor transition molding, 8ft", usageCount:1 },
  { id:67, name:"PVC Baseboard",                         cat:"Doors & Trim",      supplier:"Home Depot",     unit:"ea",  lastPrice:60.00,  upcharge:10, url:"", notes:"Waterproof baseboard, 8ft", usageCount:1 },
  { id:68, name:"Toilet Paper Holder (Matte Black)",     cat:"Doors & Trim",      supplier:"Home Depot",     unit:"ea",  lastPrice:15.36,  upcharge:10, url:"", notes:"Wall mounted accessory", usageCount:2 },

  // Cleaning
  { id:69, name:"Commercial Cleaning Agent",             cat:"Cleaning Supplies", supplier:"Other",          unit:"ea",  lastPrice:300.00, upcharge:15, url:"", notes:"Industrial tile cleaner", usageCount:1 },
  { id:70, name:"Acid Cleaner",                          cat:"Cleaning Supplies", supplier:"Other",          unit:"gal", lastPrice:150.00, upcharge:15, url:"", notes:"Post-construction acid wash", usageCount:1 },
];

// ── Styles matching CRM design system ──
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --stone-950:#1a1714; --stone-900:#241f1b; --stone-800:#332d27; --stone-700:#4a4238;
    --stone-600:#6b5e52; --stone-500:#8c7b6e; --stone-400:#b0a095; --stone-300:#cfc4ba;
    --stone-200:#e8e0d8; --stone-100:#f4f0eb; --stone-50:#faf8f5;
    --warm-gold:#c9a96e; --warm-gold-light:#dfc08a;
    --accent-green:#7a9e7e; --accent-red:#c0614a; --accent-blue:#6b8cae; --accent-amber:#c4954a;
    --shadow-sm:0 1px 3px rgba(26,23,20,0.12); --shadow-md:0 4px 12px rgba(26,23,20,0.15);
    --shadow-lg:0 8px 28px rgba(26,23,20,0.18);
    --radius:8px; --radius-lg:14px;
    --font-display:'Cormorant Garamond',serif; --font-body:'DM Sans',sans-serif;
  }
  body { background:var(--stone-100); color:var(--stone-900); font-family:var(--font-body); }
  ::-webkit-scrollbar { width:6px; height:6px; }
  ::-webkit-scrollbar-track { background:var(--stone-200); }
  ::-webkit-scrollbar-thumb { background:var(--stone-400); border-radius:3px; }
  @keyframes fadeIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
  @keyframes modalIn { from{opacity:0;transform:scale(0.97)} to{opacity:1;transform:scale(1)} }
  @keyframes slideUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  .fade-in { animation:fadeIn 0.35s ease forwards; }

  .tile-bg {
    background-image:
      linear-gradient(45deg, rgba(201,169,110,0.04) 25%, transparent 25%),
      linear-gradient(-45deg, rgba(201,169,110,0.04) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, rgba(201,169,110,0.04) 75%),
      linear-gradient(-45deg, transparent 75%, rgba(201,169,110,0.04) 75%);
    background-size:20px 20px;
    background-position:0 0, 0 10px, 10px -10px, -10px 0px;
  }
`;

const fmt = n => "$" + Number(n).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2});

export default function MaterialsCatalog() {
  const [catalog, setCatalog] = useState([]);
  const [view, setView] = useState("catalog");
  const [catFilter, setCatFilter] = useState("All");
  const [supplierFilter, setSupplierFilter] = useState("All");
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const [sortDir, setSortDir] = useState("asc");
  const [modal, setModal] = useState(null); // null | "add" | item object for edit
  const [detailItem, setDetailItem] = useState(null);
  const [form, setForm] = useState({});
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(true);
  const searchRef = useRef(null);
  const dbReady = useRef(false);
  const saveTimer = useRef(null);

  // ── Map DB row to local format ──
  const rowToItem = (r) => ({
    id: r.id, name: r.name||'', cat: r.cat||'Other', supplier: r.supplier||'',
    unit: r.unit||'ea', lastPrice: Number(r.last_price)||0, upcharge: Number(r.upcharge)||0,
    url: r.url||'', notes: r.notes||'', usageCount: Number(r.usage_count)||0,
  });
  const itemToRow = (i) => ({
    id: i.id, name: i.name||'', cat: i.cat||'Other', supplier: i.supplier||'',
    unit: i.unit||'ea', last_price: Number(i.lastPrice)||0, upcharge: Number(i.upcharge)||0,
    url: i.url||'', notes: i.notes||'', usage_count: Number(i.usageCount)||0,
  });

  // ── Load from Supabase on mount ──
  useEffect(() => {
    (async () => {
      try {
        console.log('[MaterialsCatalog] Loading from materials_catalog table...');
        const { data, error, status } = await supabase.from('materials_catalog').select('*').order('id');
        console.log('[MaterialsCatalog] Query result:', { status, error: error?.message, rowCount: data?.length });
        if (error) throw error;
        if (data && data.length > 0) {
          console.log('[MaterialsCatalog] Loaded', data.length, 'items from DB');
          setCatalog(data.map(rowToItem));
        } else {
          // Seed with default catalog on first use
          console.log('[MaterialsCatalog] Table empty, seeding with', initCatalog.length, 'items...');
          setCatalog(initCatalog);
          const rows = initCatalog.map(itemToRow);
          // Insert in batches of 50
          for (let i = 0; i < rows.length; i += 50) {
            const batch = rows.slice(i, i+50);
            const { error: seedErr } = await supabase.from('materials_catalog').upsert(batch, { onConflict: 'id' });
            if (seedErr) console.error('[MaterialsCatalog] Seed batch error:', seedErr.message, seedErr.details, seedErr.hint);
            else console.log('[MaterialsCatalog] Seeded batch', i, '-', i+batch.length);
          }
        }
      } catch (err) {
        console.error('[MaterialsCatalog] Failed to load:', err);
        setCatalog(initCatalog);
      }
      setLoading(false);
      setTimeout(() => { dbReady.current = true; }, 500);
    })();
  }, []); // eslint-disable-line

  // ── Auto-save on catalog changes (debounced) ──
  useEffect(() => {
    if (!dbReady.current || catalog.length === 0) return;
    if (saveTimer.current) clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(async () => {
      try {
        console.log('[MaterialsCatalog] Auto-saving', catalog.length, 'items...');
        const rows = catalog.map(itemToRow);
        const { error } = await supabase.from('materials_catalog').upsert(rows, { onConflict: 'id' });
        if (error) console.error('[MaterialsCatalog] Save error:', error.message, error.details, error.hint);
        else console.log('[MaterialsCatalog] Save successful');

        // Clean up deleted items from DB
        const { data: dbRows } = await supabase.from('materials_catalog').select('id');
        if (dbRows) {
          const localIds = catalog.map(i => i.id);
          const staleIds = dbRows.map(r => r.id).filter(id => !localIds.includes(id));
          if (staleIds.length > 0) {
            await supabase.from('materials_catalog').delete().in('id', staleIds);
          }
        }
      } catch (err) {
        console.error('Catalog save exception:', err.message);
      }
    }, 1500);
  }, [catalog]); // eslint-disable-line

  // ── Filtering + sorting ──
  const filtered = useMemo(() => {
    let items = [...catalog];
    if (catFilter !== "All") items = items.filter(i => i.cat === catFilter);
    if (supplierFilter !== "All") items = items.filter(i => i.supplier === supplierFilter);
    if (search) {
      const s = search.toLowerCase();
      items = items.filter(i => i.name.toLowerCase().includes(s) || i.cat.toLowerCase().includes(s) || i.supplier.toLowerCase().includes(s) || (i.notes||"").toLowerCase().includes(s));
    }
    items.sort((a,b) => {
      let va = a[sortBy], vb = b[sortBy];
      if (typeof va === "string") { va = va.toLowerCase(); vb = vb.toLowerCase(); }
      if (va < vb) return sortDir === "asc" ? -1 : 1;
      if (va > vb) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
    return items;
  }, [catalog, catFilter, supplierFilter, search, sortBy, sortDir]);

  // ── Category stats ──
  const catStats = useMemo(() => {
    const stats = {};
    Object.keys(CATALOG_CATS).forEach(c => { stats[c] = { count:0, totalValue:0, avgPrice:0 }; });
    catalog.forEach(item => {
      if (stats[item.cat]) {
        stats[item.cat].count++;
        stats[item.cat].totalValue += item.lastPrice;
      }
    });
    Object.keys(stats).forEach(c => {
      stats[c].avgPrice = stats[c].count > 0 ? stats[c].totalValue / stats[c].count : 0;
    });
    return stats;
  }, [catalog]);

  const totalItems = catalog.length;
  const totalCategories = Object.keys(CATALOG_CATS).filter(c => catStats[c]?.count > 0).length;
  const avgUpcharge = catalog.length > 0 ? Math.round(catalog.reduce((s,i) => s+i.upcharge, 0) / catalog.length) : 0;
  const uniqueSuppliers = [...new Set(catalog.map(i => i.supplier))].length;

  // ── Form handling ──
  const openAdd = () => {
    setForm({ name:"", cat:Object.keys(CATALOG_CATS)[0], supplier:SUPPLIERS[0], unit:"ea", lastPrice:"", upcharge:15, url:"", notes:"" });
    setModal("add");
  };
  const openEdit = (item) => {
    setForm({ ...item });
    setModal("edit");
  };
  const save = () => {
    if (!form.name || !form.lastPrice) return;
    if (modal === "add") {
      const newItem = { ...form, id: Date.now(), lastPrice: Number(form.lastPrice), upcharge: Number(form.upcharge), usageCount: 0 };
      setCatalog(p => [...p, newItem]);
      showToast(`"${form.name}" added to catalog`);
    } else {
      setCatalog(p => p.map(i => i.id === form.id ? { ...form, lastPrice: Number(form.lastPrice), upcharge: Number(form.upcharge) } : i));
      showToast(`"${form.name}" updated`);
    }
    setModal(null);
  };
  const del = (id) => {
    const item = catalog.find(i=>i.id===id);
    setCatalog(p => p.filter(i => i.id !== id));
    setDetailItem(null);
    showToast(`"${item?.name}" removed from catalog`);
  };
  const duplicate = (item) => {
    const newItem = { ...item, id: Date.now(), name: item.name + " (Copy)", usageCount: 0 };
    setCatalog(p => [...p, newItem]);
    showToast(`"${item.name}" duplicated`);
  };

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 3000); };

  const toggleSort = (field) => {
    if (sortBy === field) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortBy(field); setSortDir("asc"); }
  };

  const SortIcon = ({field}) => sortBy === field ? (sortDir === "asc" ? " ↑" : " ↓") : "";

  // keyboard shortcut
  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") { e.preventDefault(); searchRef.current?.focus(); }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  if (loading) return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"var(--font-body)"}}>
      <style>{styles}</style>
      <div style={{textAlign:"center"}}>
        <div style={{fontSize:32,marginBottom:12}}>📦</div>
        <div style={{fontFamily:"var(--font-display)",fontSize:20,fontWeight:600,color:"var(--stone-600)"}}>Loading Materials Catalog…</div>
      </div>
    </div>
  );

  return (
    <div className="fade-in tile-bg" style={{ minHeight:"100vh", padding:"28px", fontFamily:"var(--font-body)" }}>
      <style>{styles}</style>

      {/* ── Header ── */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 style={{ fontFamily:"var(--font-display)", fontSize:32, fontWeight:600, color:"var(--stone-900)", margin:0, lineHeight:1.1 }}>
            Materials Catalog
          </h1>
          <p style={{ fontSize:14, color:"var(--stone-500)", marginTop:6 }}>
            Price book & reference library — {totalItems} items across {totalCategories} categories
          </p>
        </div>
        <button onClick={openAdd} style={{ display:"inline-flex", alignItems:"center", gap:6, padding:"10px 20px", borderRadius:"var(--radius)", fontFamily:"var(--font-body)", fontSize:13, fontWeight:600, cursor:"pointer", border:"none", background:"var(--warm-gold)", color:"white", transition:"all 0.2s" }}
          onMouseEnter={e=>{e.currentTarget.style.background="var(--warm-gold-light)";e.currentTarget.style.transform="translateY(-1px)"}}
          onMouseLeave={e=>{e.currentTarget.style.background="var(--warm-gold)";e.currentTarget.style.transform="translateY(0)"}}>
          ＋ Add Item
        </button>
      </div>

      {/* ── View Toggle ── */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24, flexWrap:"wrap", gap:12 }}>
        <div style={{ display:"flex", background:"var(--stone-200)", borderRadius:"var(--radius-lg)", padding:4, gap:4, width:"fit-content" }}>
          {[["catalog","📋 Catalog"],["categories","🏷️ Categories"],["suppliers","🏪 Suppliers"]].map(([v,label]) => (
            <button key={v} onClick={() => setView(v)} style={{ padding:"8px 18px", borderRadius:"var(--radius)", fontSize:13, fontWeight:600, cursor:"pointer", border:"none", fontFamily:"var(--font-body)", background:view===v?"white":"transparent", color:view===v?"var(--stone-900)":"var(--stone-500)", boxShadow:view===v?"0 1px 4px rgba(0,0,0,0.1)":"none", transition:"all 0.2s" }}>
              {label}
            </button>
          ))}
        </div>
        {view === "catalog" && (
          <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
            <div style={{ position:"relative" }}>
              <input ref={searchRef} value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search catalog... (⌘K)"
                style={{ width:240, padding:"8px 12px 8px 32px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontFamily:"var(--font-body)", fontSize:13, background:"var(--stone-50)", color:"var(--stone-900)", outline:"none" }}
                onFocus={e=>e.target.style.borderColor="var(--warm-gold)"} onBlur={e=>e.target.style.borderColor="var(--stone-300)"} />
              <span style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", fontSize:14, opacity:0.4 }}>🔍</span>
            </div>
            <select value={catFilter} onChange={e=>setCatFilter(e.target.value)} style={{ padding:"8px 12px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontFamily:"var(--font-body)", fontSize:12, fontWeight:600, background:"var(--stone-50)", color:"var(--stone-600)", cursor:"pointer" }}>
              <option value="All">All Categories</option>
              {Object.keys(CATALOG_CATS).map(c => <option key={c} value={c}>{c} ({catStats[c]?.count||0})</option>)}
            </select>
            <select value={supplierFilter} onChange={e=>setSupplierFilter(e.target.value)} style={{ padding:"8px 12px", border:"1.5px solid var(--stone-300)", borderRadius:"var(--radius)", fontFamily:"var(--font-body)", fontSize:12, fontWeight:600, background:"var(--stone-50)", color:"var(--stone-600)", cursor:"pointer" }}>
              <option value="All">All Suppliers</option>
              {SUPPLIERS.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        )}
      </div>

      {/* ── Stats ── */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:14, marginBottom:24 }}>
        <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", padding:"20px 24px", border:"1px solid var(--stone-200)", boxShadow:"var(--shadow-sm)" }}>
          <div style={{ fontFamily:"var(--font-display)", fontSize:36, fontWeight:600, color:"var(--warm-gold)", lineHeight:1 }}>{totalItems}</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", fontWeight:500, letterSpacing:"0.05em", textTransform:"uppercase", marginTop:6 }}>Catalog Items</div>
        </div>
        <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", padding:"20px 24px", border:"1px solid var(--stone-200)", boxShadow:"var(--shadow-sm)" }}>
          <div style={{ fontFamily:"var(--font-display)", fontSize:36, fontWeight:600, color:"var(--accent-blue)", lineHeight:1 }}>{totalCategories}</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", fontWeight:500, letterSpacing:"0.05em", textTransform:"uppercase", marginTop:6 }}>Active Categories</div>
        </div>
        <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", padding:"20px 24px", border:"1px solid var(--stone-200)", boxShadow:"var(--shadow-sm)" }}>
          <div style={{ fontFamily:"var(--font-display)", fontSize:36, fontWeight:600, color:"var(--accent-green)", lineHeight:1 }}>{avgUpcharge}%</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", fontWeight:500, letterSpacing:"0.05em", textTransform:"uppercase", marginTop:6 }}>Avg Markup</div>
        </div>
        <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", padding:"20px 24px", border:"1px solid var(--stone-200)", boxShadow:"var(--shadow-sm)" }}>
          <div style={{ fontFamily:"var(--font-display)", fontSize:36, fontWeight:600, color:"var(--accent-amber)", lineHeight:1 }}>{uniqueSuppliers}</div>
          <div style={{ fontSize:12, color:"var(--stone-500)", fontWeight:500, letterSpacing:"0.05em", textTransform:"uppercase", marginTop:6 }}>Suppliers</div>
        </div>
      </div>

      {/* ── CATALOG VIEW ── */}
      {view === "catalog" && (
        <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", border:"1px solid var(--stone-200)", boxShadow:"var(--shadow-sm)", overflow:"hidden" }}>
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr>
                  <th onClick={()=>toggleSort("name")} style={{ ...thStyle, cursor:"pointer" }}>Item{SortIcon({field:"name"})}</th>
                  <th onClick={()=>toggleSort("cat")} style={{ ...thStyle, cursor:"pointer" }}>Category{SortIcon({field:"cat"})}</th>
                  <th onClick={()=>toggleSort("supplier")} style={{ ...thStyle, cursor:"pointer" }}>Supplier{SortIcon({field:"supplier"})}</th>
                  <th style={thStyle}>Unit</th>
                  <th onClick={()=>toggleSort("lastPrice")} style={{ ...thStyle, textAlign:"right", cursor:"pointer" }}>Last Price{SortIcon({field:"lastPrice"})}</th>
                  <th onClick={()=>toggleSort("upcharge")} style={{ ...thStyle, textAlign:"right", cursor:"pointer" }}>Markup{SortIcon({field:"upcharge"})}</th>
                  <th style={{ ...thStyle, textAlign:"right" }}>Bid Price</th>
                  <th style={{ ...thStyle, textAlign:"center", width:80 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan="8" style={{ textAlign:"center", padding:48, color:"var(--stone-400)", fontSize:13 }}>
                    <div style={{ fontSize:32, marginBottom:8 }}>📦</div>
                    No items match your filters. Try adjusting your search or filters.
                  </td></tr>
                ) : filtered.map((item, idx) => {
                  const catInfo = CATALOG_CATS[item.cat] || CATALOG_CATS["Tile"];
                  const bidPrice = item.lastPrice * (1 + item.upcharge/100);
                  return (
                    <tr key={item.id} style={{ animation:`slideUp 0.3s ease ${idx*0.02}s both` }}
                      onMouseEnter={e=>e.currentTarget.style.background="var(--stone-100)"}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      <td style={tdStyle}>
                        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                          <div style={{ width:36, height:36, borderRadius:"var(--radius)", background:catInfo.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:16, flexShrink:0 }}>{catInfo.icon}</div>
                          <div>
                            <div style={{ fontWeight:600, fontSize:13, cursor:"pointer", color:"var(--stone-900)" }} onClick={() => setDetailItem(item)}>{item.name}</div>
                            {item.notes && <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:1, maxWidth:260, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{item.notes}</div>}
                          </div>
                        </div>
                      </td>
                      <td style={tdStyle}>
                        <span style={{ background:catInfo.bg, color:catInfo.color, padding:"3px 10px", borderRadius:99, fontSize:11, fontWeight:600, whiteSpace:"nowrap" }}>{catInfo.icon} {item.cat}</span>
                      </td>
                      <td style={{ ...tdStyle, fontSize:12, color:"var(--stone-600)" }}>{item.supplier}</td>
                      <td style={{ ...tdStyle, fontSize:12, color:"var(--stone-500)" }}>{item.unit}</td>
                      <td style={{ ...tdStyle, textAlign:"right", fontFamily:"var(--font-display)", fontSize:15, fontWeight:700 }}>{fmt(item.lastPrice)}</td>
                      <td style={{ ...tdStyle, textAlign:"right" }}>
                        <span style={{ background:"rgba(122,158,126,0.12)", color:"var(--accent-green)", padding:"2px 8px", borderRadius:99, fontSize:11, fontWeight:700 }}>+{item.upcharge}%</span>
                      </td>
                      <td style={{ ...tdStyle, textAlign:"right", fontFamily:"var(--font-display)", fontSize:15, fontWeight:700, color:"var(--warm-gold)" }}>{fmt(bidPrice)}</td>
                      <td style={{ ...tdStyle, textAlign:"center" }}>
                        <div style={{ display:"flex", gap:4, justifyContent:"center" }}>
                          <button onClick={() => openEdit(item)} title="Edit" style={iconBtnStyle}>✏️</button>
                          <button onClick={() => duplicate(item)} title="Duplicate" style={iconBtnStyle}>📋</button>
                          <button onClick={() => del(item.id)} title="Delete" style={{ ...iconBtnStyle, color:"var(--accent-red)" }}>🗑</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ padding:"12px 18px", borderTop:"1px solid var(--stone-200)", display:"flex", justifyContent:"space-between", alignItems:"center", fontSize:12, color:"var(--stone-400)" }}>
            <span>Showing {filtered.length} of {catalog.length} items</span>
            <span>Click column headers to sort · Click item name for details</span>
          </div>
        </div>
      )}

      {/* ── CATEGORIES VIEW ── */}
      {view === "categories" && (
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:16 }}>
          {Object.entries(CATALOG_CATS).map(([catName, catInfo]) => {
            const items = catalog.filter(i => i.cat === catName);
            const avgPrice = items.length > 0 ? items.reduce((s,i)=>s+i.lastPrice,0)/items.length : 0;
            const topItems = items.sort((a,b) => b.usageCount - a.usageCount).slice(0,3);
            return (
              <div key={catName} style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", border:"1px solid var(--stone-200)", boxShadow:"var(--shadow-sm)", overflow:"hidden", transition:"all 0.2s", cursor:"pointer" }}
                onClick={() => { setCatFilter(catName); setView("catalog"); }}
                onMouseEnter={e=>{e.currentTarget.style.boxShadow="var(--shadow-md)";e.currentTarget.style.transform="translateY(-2px)"}}
                onMouseLeave={e=>{e.currentTarget.style.boxShadow="var(--shadow-sm)";e.currentTarget.style.transform="translateY(0)"}}>
                {/* Category header */}
                <div style={{ padding:"18px 20px", borderBottom:"1px solid var(--stone-200)", display:"flex", alignItems:"center", gap:12 }}>
                  <div style={{ width:44, height:44, borderRadius:"var(--radius)", background:catInfo.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:22 }}>{catInfo.icon}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontFamily:"var(--font-display)", fontSize:17, fontWeight:700, color:"var(--stone-900)" }}>{catName}</div>
                    <div style={{ fontSize:11, color:"var(--stone-400)", marginTop:1 }}>{catInfo.desc}</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, color:catInfo.color }}>{items.length}</div>
                    <div style={{ fontSize:10, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em" }}>items</div>
                  </div>
                </div>
                {/* Quick stats */}
                <div style={{ padding:"14px 20px" }}>
                  {items.length > 0 ? (
                    <>
                      <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, marginBottom:10 }}>
                        <span style={{ color:"var(--stone-500)" }}>Avg Price</span>
                        <span style={{ fontWeight:700, color:"var(--stone-700)" }}>{fmt(avgPrice)}</span>
                      </div>
                      <div style={{ fontSize:11, color:"var(--stone-400)", marginBottom:4 }}>Most used:</div>
                      {topItems.map(item => (
                        <div key={item.id} style={{ fontSize:12, color:"var(--stone-600)", padding:"3px 0", display:"flex", justifyContent:"space-between" }}>
                          <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:180 }}>{item.name}</span>
                          <span style={{ fontWeight:600, color:catInfo.color, flexShrink:0, marginLeft:8 }}>{fmt(item.lastPrice)}</span>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div style={{ fontSize:12, color:"var(--stone-400)", textAlign:"center", padding:"8px 0" }}>No items yet</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── SUPPLIERS VIEW ── */}
      {view === "suppliers" && (
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))", gap:16 }}>
          {SUPPLIERS.filter(s => catalog.some(i => i.supplier === s)).map(supplier => {
            const items = catalog.filter(i => i.supplier === supplier);
            const totalValue = items.reduce((s,i) => s+i.lastPrice, 0);
            const cats = [...new Set(items.map(i => i.cat))];
            return (
              <div key={supplier} style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", border:"1px solid var(--stone-200)", boxShadow:"var(--shadow-sm)", padding:20, cursor:"pointer" }}
                onClick={() => { setSupplierFilter(supplier); setView("catalog"); }}
                onMouseEnter={e=>{e.currentTarget.style.boxShadow="var(--shadow-md)";e.currentTarget.style.transform="translateY(-2px)"}}
                onMouseLeave={e=>{e.currentTarget.style.boxShadow="var(--shadow-sm)";e.currentTarget.style.transform="translateY(0)"}}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:12 }}>
                  <div>
                    <div style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, marginBottom:2 }}>🏪 {supplier}</div>
                    <div style={{ fontSize:12, color:"var(--stone-400)" }}>{items.length} items · {cats.length} categories</div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ fontFamily:"var(--font-display)", fontSize:18, fontWeight:700, color:"var(--accent-blue)" }}>{fmt(totalValue)}</div>
                    <div style={{ fontSize:10, color:"var(--stone-400)", textTransform:"uppercase" }}>Total Catalog Value</div>
                  </div>
                </div>
                <div style={{ display:"flex", flexWrap:"wrap", gap:4 }}>
                  {cats.map(c => {
                    const ci = CATALOG_CATS[c];
                    return ci ? <span key={c} style={{ background:ci.bg, color:ci.color, padding:"2px 8px", borderRadius:99, fontSize:10, fontWeight:600 }}>{ci.icon} {c}</span> : null;
                  })}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Add/Edit Modal ── */}
      {modal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(26,23,20,0.55)", backdropFilter:"blur(4px)", zIndex:1000, overflow:"auto", display:"flex", justifyContent:"center", alignItems:"flex-start", padding:"40px 20px 80px" }}>
          <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", padding:32, width:"100%", maxWidth:580, boxShadow:"var(--shadow-lg)", animation:"modalIn 0.25s ease", position:"relative", margin:"auto 0" }}>
            <button onClick={()=>setModal(null)} style={{ position:"absolute", top:16, right:16, background:"none", border:"none", fontSize:18, cursor:"pointer", color:"var(--stone-400)", padding:4 }}>✕</button>
            <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, marginBottom:20 }}>{modal === "add" ? "Add Catalog Item" : "Edit Catalog Item"}</h2>

            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
              <div style={{ gridColumn:"1/-1" }}>
                <label style={labelStyle}>Item Name</label>
                <input value={form.name||""} onChange={e=>setForm(p=>({...p,name:e.target.value}))} placeholder="e.g., Mapei Keraflex Thinset" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Category</label>
                <select value={form.cat||""} onChange={e=>setForm(p=>({...p,cat:e.target.value}))} style={inputStyle}>
                  {Object.keys(CATALOG_CATS).map(c => <option key={c} value={c}>{CATALOG_CATS[c].icon} {c}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Supplier</label>
                <select value={form.supplier||""} onChange={e=>setForm(p=>({...p,supplier:e.target.value}))} style={inputStyle}>
                  {SUPPLIERS.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Unit</label>
                <select value={form.unit||""} onChange={e=>setForm(p=>({...p,unit:e.target.value}))} style={inputStyle}>
                  {UNITS.map(u => <option key={u} value={u}>{u}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Last Known Price ($)</label>
                <input type="number" step="0.01" value={form.lastPrice||""} onChange={e=>setForm(p=>({...p,lastPrice:e.target.value}))} placeholder="0.00" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Markup %</label>
                <input type="number" value={form.upcharge||""} onChange={e=>setForm(p=>({...p,upcharge:e.target.value}))} placeholder="15" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Bid Price (auto)</label>
                <div style={{ ...inputStyle, background:"var(--stone-100)", color:"var(--warm-gold)", fontWeight:700, fontFamily:"var(--font-display)", fontSize:16, display:"flex", alignItems:"center" }}>
                  {form.lastPrice ? fmt(Number(form.lastPrice) * (1 + Number(form.upcharge||0)/100)) : "—"}
                </div>
              </div>
              <div style={{ gridColumn:"1/-1" }}>
                <label style={labelStyle}>Product URL</label>
                <input value={form.url||""} onChange={e=>setForm(p=>({...p,url:e.target.value}))} placeholder="https://..." style={inputStyle} />
              </div>
              <div style={{ gridColumn:"1/-1" }}>
                <label style={labelStyle}>Notes</label>
                <textarea value={form.notes||""} onChange={e=>setForm(p=>({...p,notes:e.target.value}))} rows={2} placeholder="Size, color, special instructions..." style={{ ...inputStyle, resize:"vertical" }} />
              </div>
            </div>

            <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:24 }}>
              <button onClick={()=>setModal(null)} style={{ ...btnStyle, background:"var(--stone-200)", color:"var(--stone-800)" }}>Cancel</button>
              <button onClick={save} style={{ ...btnStyle, background:"var(--warm-gold)", color:"white" }}>
                {modal === "add" ? "Add to Catalog" : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Detail Panel ── */}
      {detailItem && (
        <div style={{ position:"fixed", inset:0, background:"rgba(26,23,20,0.55)", backdropFilter:"blur(4px)", zIndex:1000, overflow:"auto", display:"flex", justifyContent:"center", alignItems:"flex-start", padding:"40px 20px 80px" }}>
          <div style={{ background:"var(--stone-50)", borderRadius:"var(--radius-lg)", padding:32, width:"100%", maxWidth:520, boxShadow:"var(--shadow-lg)", animation:"modalIn 0.25s ease", position:"relative", margin:"auto 0" }}>
            <button onClick={()=>setDetailItem(null)} style={{ position:"absolute", top:16, right:16, background:"none", border:"none", fontSize:18, cursor:"pointer", color:"var(--stone-400)", padding:4 }}>✕</button>
            {(() => {
              const ci = CATALOG_CATS[detailItem.cat] || {};
              const bidPrice = detailItem.lastPrice * (1 + detailItem.upcharge/100);
              return (
                <>
                  <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:20 }}>
                    <div style={{ width:56, height:56, borderRadius:"var(--radius-lg)", background:ci.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:28 }}>{ci.icon}</div>
                    <div>
                      <h2 style={{ fontFamily:"var(--font-display)", fontSize:22, fontWeight:700, margin:0 }}>{detailItem.name}</h2>
                      <span style={{ background:ci.bg, color:ci.color, padding:"2px 10px", borderRadius:99, fontSize:11, fontWeight:600 }}>{detailItem.cat}</span>
                    </div>
                  </div>

                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:20 }}>
                    <div style={{ background:"var(--stone-100)", borderRadius:"var(--radius)", padding:14, textAlign:"center" }}>
                      <div style={{ fontSize:10, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:4 }}>Cost</div>
                      <div style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700 }}>{fmt(detailItem.lastPrice)}</div>
                      <div style={{ fontSize:11, color:"var(--stone-400)" }}>per {detailItem.unit}</div>
                    </div>
                    <div style={{ background:"rgba(122,158,126,0.08)", borderRadius:"var(--radius)", padding:14, textAlign:"center" }}>
                      <div style={{ fontSize:10, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:4 }}>Markup</div>
                      <div style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"var(--accent-green)" }}>+{detailItem.upcharge}%</div>
                      <div style={{ fontSize:11, color:"var(--stone-400)" }}>{fmt(bidPrice - detailItem.lastPrice)} margin</div>
                    </div>
                    <div style={{ background:"rgba(201,169,110,0.08)", borderRadius:"var(--radius)", padding:14, textAlign:"center" }}>
                      <div style={{ fontSize:10, color:"var(--stone-400)", textTransform:"uppercase", letterSpacing:"0.05em", marginBottom:4 }}>Bid Price</div>
                      <div style={{ fontFamily:"var(--font-display)", fontSize:20, fontWeight:700, color:"var(--warm-gold)" }}>{fmt(bidPrice)}</div>
                      <div style={{ fontSize:11, color:"var(--stone-400)" }}>per {detailItem.unit}</div>
                    </div>
                  </div>

                  <div style={{ borderTop:"1px solid var(--stone-200)", paddingTop:16, marginBottom:16 }}>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                      <div><span style={{ fontSize:11, color:"var(--stone-400)", textTransform:"uppercase" }}>Supplier</span><div style={{ fontSize:13, fontWeight:600, marginTop:2 }}>🏪 {detailItem.supplier}</div></div>
                      <div><span style={{ fontSize:11, color:"var(--stone-400)", textTransform:"uppercase" }}>Used in Projects</span><div style={{ fontSize:13, fontWeight:600, marginTop:2 }}>{detailItem.usageCount} times</div></div>
                    </div>
                  </div>

                  {detailItem.notes && (
                    <div style={{ background:"var(--stone-100)", borderRadius:"var(--radius)", padding:12, marginBottom:16 }}>
                      <div style={{ fontSize:11, color:"var(--stone-400)", textTransform:"uppercase", marginBottom:4 }}>Notes</div>
                      <div style={{ fontSize:13, color:"var(--stone-700)" }}>{detailItem.notes}</div>
                    </div>
                  )}

                  {detailItem.url && (
                    <div style={{ marginBottom:16 }}>
                      <div style={{ fontSize:11, color:"var(--stone-400)", textTransform:"uppercase", marginBottom:4 }}>Product Link</div>
                      <div style={{ fontSize:12, color:"var(--accent-blue)", wordBreak:"break-all" }}>{detailItem.url}</div>
                    </div>
                  )}

                  <div style={{ display:"flex", gap:8, justifyContent:"flex-end", borderTop:"1px solid var(--stone-200)", paddingTop:16 }}>
                    <button onClick={() => { setDetailItem(null); openEdit(detailItem); }} style={{ ...btnStyle, background:"var(--stone-200)", color:"var(--stone-800)" }}>✏️ Edit</button>
                    <button onClick={() => { duplicate(detailItem); setDetailItem(null); }} style={{ ...btnStyle, background:"var(--stone-200)", color:"var(--stone-800)" }}>📋 Duplicate</button>
                    <button onClick={() => del(detailItem.id)} style={{ ...btnStyle, background:"var(--accent-red)", color:"white" }}>🗑 Delete</button>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}

      {/* ── Toast ── */}
      {toast && (
        <div style={{ position:"fixed", bottom:24, left:"50%", transform:"translateX(-50%)", background:"var(--stone-800)", color:"white", borderRadius:"var(--radius)", padding:"10px 20px", fontSize:13, fontWeight:500, boxShadow:"0 4px 16px rgba(0,0,0,0.3)", animation:"modalIn 0.3s ease", zIndex:2000, display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ color:"var(--warm-gold)" }}>✓</span> {toast}
        </div>
      )}
    </div>
  );
}

// ── Shared inline style objects ──
const thStyle = { textAlign:"left", padding:"11px 16px", fontSize:11, fontWeight:600, letterSpacing:"0.06em", textTransform:"uppercase", color:"#8c7b6e", borderBottom:"2px solid #e8e0d8", userSelect:"none", whiteSpace:"nowrap" };
const tdStyle = { padding:"13px 16px", fontSize:13, borderBottom:"1px solid #e8e0d8", verticalAlign:"middle" };
const inputStyle = { width:"100%", padding:"9px 12px", border:"1.5px solid #cfc4ba", borderRadius:8, fontFamily:"'DM Sans',sans-serif", fontSize:14, background:"#faf8f5", color:"#241f1b", outline:"none" };
const labelStyle = { fontSize:12, fontWeight:600, color:"#6b5e52", letterSpacing:"0.05em", textTransform:"uppercase", display:"block", marginBottom:5 };
const btnStyle = { display:"inline-flex", alignItems:"center", gap:6, padding:"9px 18px", borderRadius:8, fontFamily:"'DM Sans',sans-serif", fontSize:13, fontWeight:500, cursor:"pointer", border:"none", transition:"all 0.2s" };
const iconBtnStyle = { padding:5, borderRadius:6, background:"transparent", cursor:"pointer", border:"none", fontSize:14, transition:"all 0.2s", display:"inline-flex", alignItems:"center" };
